import { render } from "./Results.Details.vue?vue&type=template&id=1d7f6eed"
import script from "./Results.Details.vue?vue&type=script&lang=js"
export * from "./Results.Details.vue?vue&type=script&lang=js"

import "./Results.Details.vue?vue&type=style&index=0&id=1d7f6eed&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__